export default __webpack_public_path__ + "static/media/whatsappGreen.1ff2093e.svg";